{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "בחר פריט",
  "tableResizer": "שינוי גודל",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
